import { StorefrontProductResult, StorefrontProductResultItem } from '../clients/Storefront/Models/StorefrontProductResult';
import { StorefrontClient } from '../clients/Storefront/StorefrontClient';
import { ITabStateProvider } from './ITabStateProvider';
import { SearchEntryState } from './SearchEntryState';
import { SearchTabState } from './SearchTabState';

export class StorefrontTabStateProvider implements ITabStateProvider {
    entriesPerPage: number;
    client: StorefrontClient;
    async GetTabs(query: string): Promise<SearchTabState[]> {
        const state = new SearchTabState('Products', 'products', this);
        if(!query || query === '')
        {
            return [state];
        }
        const result = await this.client.getProductResults(query, 0);
        state.patch({
            allPages: Math.ceil(result.total / this.entriesPerPage),
            entries: result.items.map(x => this.factory(x, result)),
            page: Math.ceil(result.skip / result.total),
            count: result.total,
            query: query
        });
        return [state];
    }
    private factory: (value: StorefrontProductResultItem, result: StorefrontProductResult) => SearchEntryState =
        (x, result) => new SearchEntryState(
          'Products',
          x.name,
          this.client.createUrlToProduct(x.id, x.familyId, result.storeId, result.languageCode, x.configurationCode, x.isExactMatchCode),
          x.description,
          [x.configurationCode, x.id, x.familyId],
          x.imageUrl
        );

    async Update(page: number, issuer: SearchTabState) {
        var lastQuery = issuer.query;
        const result = await this.client.getProductResults(lastQuery, page * this.entriesPerPage);
        issuer.patch({
            allPages: Math.ceil(result.total / this.entriesPerPage),
            entries: result.items.map(x => this.factory(x, result)),
            page: Math.ceil(result.skip / this.entriesPerPage),
            count: result.total,
        });
    }
    constructor(client: StorefrontClient, entriesPerPage: number) {
        this.client = client;
        this.entriesPerPage = entriesPerPage;
    }
}
